/**
 * Modes Domain — Public API (Barrel Export)
 *
 * Learning Lab mode system: engine, registry, selectors, and types.
 * External consumers should import from this barrel only.
 */

// Types
export type { ModeId, ModeMetadata, FluencyConfig, SprintConfig, ChallengeConfig, ExperimentsConfig, ModeSessionConfig } from './types';

// Mode engine
export { createModeSession } from './modeEngine';
export type { ModeSessionResult } from './modeEngine';

// Mode registry
export { MODE_REGISTRY, getModeMetadata, getEnabledModes, getModeIcon } from './modeRegistry';

// Mode selectors
export { getFluencyQuestions, getSprintQuestions, getChallengeQuestions, getExperimentsQuestions, buildFrontierMasteryInputs, isFluencyColdStart } from './modeSelectors';